import styled from "styled-components";

export const Container = styled.section`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    padding: 35px 0 45px;
`
export const Text = styled.h2`
    font-size: 36px;
    text-align: center;
    color: #ffffff;
    text-transform: uppercase;
    letter-spacing: 6px;
    padding: 58px 0;
    position: relative;
    &::after{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: white;
        bottom: 17px;
        right: 50%;
        transform: translateX(50%);
    }
    &::before{
        position: absolute;
        content: "";
        width: 30px;
        height: 3px;
        background-color: white;
        top: 17px;
        right: 50%;
        transform: translateX(50%);
    }
`